import { ServerError } from '@apollo/client';
import { CombinedGraphQLErrors } from '@apollo/client/errors';

// eslint-disable-next-line
export function extractGraphQLErrors(error: unknown): any[] | undefined {
  if (CombinedGraphQLErrors.is(error)) {
    return error.errors?.length ? [...error.errors] : undefined;
  }
  return undefined;
}

// eslint-disable-next-line
export function extractNetworkErrors(error: unknown): any[] | undefined {
  if (ServerError.is(error)) {
    try {
      const parsed = JSON.parse(error.bodyText);
      return Array.isArray(parsed?.errors) && parsed.errors.length > 0 ? parsed.errors : undefined;
    } catch {
      return undefined;
    }
  }
  return undefined;
}
